import { AUTH_URL } from "app/constants/variables";
import {
  IdentityComment,
  IdentityPayload,
  MissingIdentity,
  SupportedDocument,
} from "app/models/identities";

import request from "../request";
import { BaseResponse, GenericResponse } from "../types";
import {
  CreateIdentityPayload,
  GetUploadedDocumentsResponse,
  RetrieveFlowResponse,
  StartOnboardingPayload,
  StartOnboardingResponse,
  VerificationStatusResponse,
} from "./types";
import { InitializeBvnChangeResponse } from "../profile/types";

const defaultOption = { baseURL: AUTH_URL };

export const getUploadedDocuments = () => {
  return request.get<GenericResponse<GetUploadedDocumentsResponse>>(
    "/identities/documents",
    defaultOption
  );
};

export const createIdentity = (payload: CreateIdentityPayload) => {
  return request.post<BaseResponse>("/identities", payload, defaultOption);
};

export const getMissingIdentities = () => {
  return request.get<GenericResponse<MissingIdentity[]>>(
    "/identities/missing",
    defaultOption
  );
};

export const checkVerificationStatus = () => {
  return request.get<GenericResponse<{ has_pending: boolean }>>(
    "/identities/exists",
    defaultOption
  );
};

export const retrieveFlow = () => {
  return request.get<GenericResponse<RetrieveFlowResponse>>(
    "/identities/flow",
    defaultOption
  );
};

export const getVerificationStatus = async () => {
  return await request.get<GenericResponse<VerificationStatusResponse>>(
    "/identities/status",
    defaultOption
  );
};

export const startOnboarding = (payload: StartOnboardingPayload) => {
  return request.post<GenericResponse<StartOnboardingResponse>>(
    "/identities/kyc",
    payload,
    defaultOption
  );
};

export const getIdentitiesEvents = () => {
  return request.get<GenericResponse<IdentityComment[]>>(
    "/identities/business/events",
    defaultOption
  );
};

export const addIdentitiesEvents = (payload: IdentityPayload) => {
  return request.post<GenericResponse<IdentityPayload>>(
    "/identities/business/comment",
    payload,
    defaultOption
  );
};

export const getSupportedDocuments = (country: string) => {
  return request.get<GenericResponse<SupportedDocument[]>>(
    `/identities/supported-documents/${country}`,
    defaultOption
  );
};

export const initializeBvnVerification = (payload: { bvn: string }) => {
  return request.post<{ data: InitializeBvnChangeResponse }>(
    `/identities/bvn/initialize`,
    payload,
    defaultOption
  );
};
